<script>
	export let id = null
	export let padded = false
</script>

<div {id} class="anchor" class:padded />

<style lang="scss">
	.anchor {
		position: relative;
		top: -100px;
	}
</style>
